module.exports = __webpack_public_path__ + "static/ceo-pc-af61c190d70640461d9658b3e4418eb8.png";